import { render } from "./UaError.vue?vue&type=template&id=452f42c8&scoped=true"
import script from "./UaError.vue?vue&type=script&lang=js"
export * from "./UaError.vue?vue&type=script&lang=js"

import "./UaError.vue?vue&type=style&index=0&id=452f42c8&lang=less&scoped=true"

import exportComponent from "D:\\project\\weshow-ent-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452f42c8"]])

export default __exports__